export default __webpack_public_path__ + "static/media/logo.f40915ea.png";